const Language = [
  { name: 'English', code: 'en' },
  { name: 'Hindi', code: 'hi' },
  { name: 'Urdu', code: 'ur' },
  { name: 'Telugu', code: 'te' },
];

const SampleTexts = [
  {
    name: "English",
    lang: "en",
    text: "Welcome to Translation system.",
  },
  {
    name: "Hindi",
    lang: "hi",
    text: "अनुवाद प्रणाली में आपका स्वागत है।",
  },
  {
    name: "Urdu",
    lang: "ur",
    text: "ترجمہ کے نظام میں خوش آمدید۔",
  },
  // Add more sample texts as needed
];

const Engine = [
  { code: "google", name: "Google" },
  { code: "bhashini", name: "Bhashini" },
];

export { Language, SampleTexts, Engine };